import { BaseSelectorOption, MultiSelectorProps } from "@/types";
import { Component } from "react";
import { withLocale, WithLocaleProps } from "../../providers/LocaleProvider";
import { MultiSelector } from "./MultiSelector";

interface MultiCourseSelectorProps<
  TOption extends BaseSelectorOption = BaseSelectorOption
> extends MultiSelectorProps<TOption> {}

class MultiCourseSelectorBase<
  TOption extends BaseSelectorOption = BaseSelectorOption
> extends Component<MultiCourseSelectorProps<TOption>> {
  constructor(props: any) {
    super(props);

    this.state = {};
  }

  render() {
    const { translate, ...rest } = this.props;
    return (
      <MultiSelector
        {...rest}
        translate={translate}
        label={translate?.("entities.trainings") ?? "Courses"}
        placeHolder={translate?.("placeholders.searchAndAddTraining") ?? "Search and add training"}
        hasNewItem={false}
        hasAllItem={false}
      />
    );
  }
}

// export const MultiCourseSelector = withLocale(MultiCourseSelectorBase);
export const MultiCourseSelector = withLocale(MultiCourseSelectorBase) as <
  T extends BaseSelectorOption = BaseSelectorOption
>(
  props: Omit<MultiSelectorProps<T>, keyof WithLocaleProps> &
    React.RefAttributes<MultiCourseSelectorBase<T>>
) => React.ReactElement;
